import { TrainingDialogProps, StartDialogProps } from "./Training.types";
import OpenTest from "./dialogs/OpenTest";
import PurchaseTest from "./dialogs/PurchaseTest";
import StartDialog from "./dialogs/StartDialog";
// import SubmitTest from "./dialogs/SubmitTest";

const TrainingDialogs = ({
  action,
  certificationType,
  onAction,
  onClose,
  openTestUrl,
  user,
}: TrainingDialogProps) => {
  const sharedStartProps = { onAction, onClose };
  const sharedProps = { ...sharedStartProps, user, action };
  const startDialog = (type: StartDialogProps["type"]) => (
    <StartDialog {...sharedStartProps} type={type} isOpen={action === type} />
  );

  return (
    <>
      {startDialog("start-credential")}
      {startDialog("start-core-certification")}
      {startDialog("start-gold-certification")}
      {startDialog("start-elective-courses")}
      {startDialog("start-employee-courses")}

      <OpenTest openTestUrl={openTestUrl} {...sharedProps} />
      {/* <SubmitTest {...sharedProps} /> */}
      <PurchaseTest {...sharedProps} certificationType={certificationType} />
    </>
  );
};

export default TrainingDialogs;
